import { render, staticRenderFns } from "./GenerateAccount.vue?vue&type=template&id=3459c77a&scoped=true"
import script from "./GenerateAccount.vue?vue&type=script&lang=js"
export * from "./GenerateAccount.vue?vue&type=script&lang=js"
import style0 from "./GenerateAccount.vue?vue&type=style&index=0&id=3459c77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3459c77a",
  null
  
)

export default component.exports